import React from "react";
import { AriaMenuProps, useMenu } from "react-aria";
import { useTreeState } from "react-stately";
import { Prettify } from "../../utils/types";
import * as S from "./styled";
import MenuItem from "./MenuItem";
import MenuSection from "./MenuSection";
import { MenuProps } from "./types";

export type MenuListProps<T> = Prettify<MenuProps<T> & AriaMenuProps<T>>;

const MenuList = <T extends object>(props: MenuListProps<T>) => {
    const state = useTreeState<T>(props);
    const ref = React.useRef(null);
    const { menuProps } = useMenu(props, state, ref);

    return (
        <S.List column as="ul" {...menuProps} ref={ref}>
            {[...state.collection].map(item =>
                item.type === "section" ? (
                    <MenuSection key={item.key} section={item} state={state} />
                ) : (
                    <MenuItem key={item.key} item={item} state={state} />
                )
            )}
        </S.List>
    );
};

export default MenuList;
